import { t } from "@lingui/core/macro";

import { PlanPeriodTo } from "@/generated/api/users";

const getLocalizedPeriods = (): Record<PlanPeriodTo["type"], string> => ({
  DAILY: t`Denní`,
  MONTHLY: t`Měsíční`,
  QUARTERLY: t`Čvrtletní`,
  YEARLY: t`Roční`,
});

export { getLocalizedPeriods };
